// src/contexts/vendas/NaturezaContext.js
import React, { createContext, useContext, useState, useEffect, useCallback, useRef } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';
import NaturezaCad from '../../pages/vendas/NaturezaCad';
import NaturezaSearch from '../../pages/vendas/NaturezaSearch';

const NaturezaContext = createContext();

export const useNatureza = () => useContext(NaturezaContext);

export const NaturezaProvider = ({ children }) => {
    const [naturezas, setNaturezas] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const [showSearchNatureza, setShowSearchNatureza] = useState(false);
    const tempOnSelectNaturezaRef = useRef(null);
    
    const handleShowNaturezaSearch = () => {
        return new Promise((resolve) => {
            setShowSearchNatureza(true);
            const handleSelect = (naturezaSelect) => {
                setShowSearchNatureza(false);
                resolve(naturezaSelect || null);
            };
            tempOnSelectNaturezaRef.current = handleSelect;
        });
    };
    const handleCloseSearchModal = () => {
        setShowSearchNatureza(false);
        tempOnSelectNaturezaRef.current = null;
    };

    const [showCadNatureza, setShowCadNatureza] = useState(false);
    const showNaturezaCad = () => {
        setShowCadNatureza(true);
    };

    const handleSelectNatureza = () => {
        setShowSearchNatureza(false);
    };

    const handleSelectNaturezaSearch = (naturezaSelect) => {
        const onSelect = tempOnSelectNaturezaRef.current || handleSelectNatureza;
        onSelect(naturezaSelect);
    };
            

    const fetchNaturezas = useCallback(async () => {
        try {
            const result = await fetchData('/Natureza');
            setNaturezas(result);
        } catch (error) {
            console.error("Erro ao buscar naturezas:", error);
            showMessage(`Erro ao buscar naturezas! ${error?.message || error}`, 'danger');
        }
    }, [showMessage]);

    useEffect(() => {
        fetchNaturezas();
    }, [fetchNaturezas]);

    const addNatureza = async (natureza) => {
        try {
            const result = await postData('/Natureza', natureza);
            setNaturezas([...naturezas, result]);
            showAlert('Natureza adicionada com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar natureza:", error);
            showMessage('Erro ao adicionar natureza!\n' + error, 'danger');
        }
    };

    const updateNatureza = async (natureza) => {
        try {
            const result = await putData('/Natureza', natureza);
            setNaturezas((naturezas) =>
                naturezas.map((n) => (n.id === result.id ? result : n))
            );
            showAlert('Natureza alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar natureza:", error);
            showAlert('Erro ao alterar natureza!', 'danger');
        }
    };

    const deleteNatureza = async (id) => {
        try {
            await deleteData('/Natureza', { naturezaId: id });
            setNaturezas(naturezas.filter(n => n.id !== id));
            showAlert('Natureza excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir natureza:", error);
            showAlert('Erro ao excluir natureza!', 'danger');
        }
    };

    return (
        <NaturezaContext.Provider value={{ naturezas, addNatureza, updateNatureza, deleteNatureza, handleShowNaturezaSearch, showNaturezaCad }}>
            {children}
            
            <NaturezaSearch
                show={showSearchNatureza}
                onHide={handleCloseSearchModal}
                onSelectNatureza={handleSelectNaturezaSearch}
            />
            <NaturezaCad
              show={showCadNatureza}
              onHide={()=>setShowCadNatureza(false)}
            /> 
            
        </NaturezaContext.Provider>
    );
};
